var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTestClaims = function SvgTestClaims(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration/Dashboard/TestClaims",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GraphicIllust_TestClaims",
    transform: "translate(0.000000, -1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D1E7DD",
    points: "80 13.63 15.39 13.63 2.45 81.55 67.61 81.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8DC4AE",
    points: "68.93 74.56 3.83 74.56 4.48 71.44 69.4 71.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29,71.74 L0.85,71.74 C0.380557963,71.74 -0.000525857925,71.359442 -0.000525857925,70.89 C-0.00809503405,70.6584869 0.0775510086,70.4334984 0.237547661,70.2659725 C0.397544313,70.0984466 0.61835945,70.0025522 0.85,70 L73.29,70 C73.6175407,69.9645255 73.9365616,70.1192899 74.1114414,70.3985002 C74.2863213,70.6777105 74.2863213,71.0322895 74.1114414,71.3114998 C73.9365616,71.5907101 73.6175407,71.7454745 73.29,71.71 L73.29,71.74 Z",
    id: "Path",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "64.93 37.6 64.79 16.32 64.75 10.69 30.98 10.92 31.02 16.55 31.22 45.63 43.21 45.55 43.14 35.22 51.78 35.17 51.85 45.49 64.99 45.4 64.94 37.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.37,46.49 L30.12,10.08 L65.6,9.83 L65.85,46.25 L51,46.35 L50.94,36 L44,36 L44.07,46.32 L30.37,46.49 Z M31.84,11.77 L32.06,44.77 L42.35,44.69 L42.28,34.37 L52.63,34.3 L52.7,44.62 L64.13,44.55 L63.9,11.55 L31.84,11.77 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7B80AF",
    points: "64.76 17.66 60.1 22.97 55.43 19.2 51.7 22.98 47.45 19.25 43.73 23.03 39.95 19.3 36.22 23.08 31.02 17.49 30.98 10.92 64.75 10.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2,24.32 L30.2,17.83 L30.15,10.08 L65.6,9.83 L65.6,18 L60.2,24.15 L55.49,20.35 L51.74,24.15 L47.49,20.42 L43.73,24.24 L40,20.51 L36.2,24.32 Z M31.87,17.15 L36.24,21.85 L39.94,18.1 L43.72,21.82 L47.41,18.08 L51.66,21.8 L55.36,18.05 L60,21.79 L63.9,17.34 L63.9,11.55 L31.84,11.77 L31.87,17.15 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(48.077728, 7.912583) rotate(-0.390000) translate(-48.077728, -7.912583) ",
    x: 38.3227275,
    y: 0.932583139,
    width: 19.51,
    height: 13.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.52,15.81 L37.41,0.15 L58.63,0 L58.74,15.67 L37.52,15.81 Z M39.13,1.81 L39.21,14.06 L57,14 L56.93,1.72 L39.13,1.81 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.94,
    y1: 4.22,
    x2: 47.99,
    y2: 11.38,
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,12.23 C47.530558,12.23 47.15,11.849442 47.15,11.38 L47.15,4.23 C47.1499682,3.75891311 47.528945,3.37547775 48,3.37 C48.4651296,3.37507096 48.8439877,3.74511844 48.86,4.21 L48.86,11.37 C48.8653879,11.5962266 48.7792724,11.8150582 48.6211541,11.9769412 C48.4630358,12.1388243 48.2462908,12.23 48.02,12.23 L48,12.23 Z",
    id: "Path",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.01,
    y1: 7.74,
    x2: 51.83,
    y2: 7.68,
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,8.59 C43.5634297,8.54271699 43.2326013,8.17412331 43.2326013,7.735 C43.2326013,7.29587669 43.5634297,6.92728301 44,6.88 L51.83,6.88 C52.1575407,6.8445255 52.4765616,6.99928988 52.6514414,7.27850017 C52.8263213,7.55771047 52.8263213,7.91228953 52.6514414,8.19149983 C52.4765616,8.47071012 52.1575407,8.6254745 51.83,8.59 L44,8.59 Z",
    id: "Path",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.68,33.23 L25.68,35.08 C25.6695041,35.575992 25.4623476,36.0474863 25.104128,36.3907019 C24.7459084,36.7339176 24.2659872,36.9207229 23.77,36.91 L20,36.83 C17.3471057,36.7741535 15.1500948,38.8771985 15.09,41.53 L14.78,57.6 L42.83,57.5 L42.83,42.12 C42.8567997,40.8468819 42.3766143,39.6152888 41.4951347,38.6962994 C40.6136551,37.77731 39.4031296,37.2462471 38.13,37.22 L34.37,37.14 C33.874008,37.1295041 33.4025137,36.9223476 33.0592981,36.564128 C32.7160824,36.2059084 32.5292771,35.7259872 32.54,35.23 L32.54,33.13",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.91,58.46 L14.21,41.46 C14.3133468,38.3588997 16.8981739,35.9213943 20,36 L23.76,36.08 C24.3122847,36.08 24.76,35.6322847 24.76,35.08 L24.76,33.24 C24.76,32.770558 25.140558,32.39 25.61,32.39 C26.079442,32.39 26.46,32.770558 26.46,33.24 L26.46,35.09 C26.4442613,35.8114465 26.1424836,36.497071 25.6210936,36.995955 C25.0997036,37.4948389 24.4014388,37.7660897 23.68,37.75 L20,37.68 C17.8277384,37.6465776 16.0383409,39.3778196 16,41.55 L15.73,56.75 L42,56.65 L42,42.12 C42.0011407,39.9606492 40.2882104,38.1901786 38.13,38.12 L34.35,38 C33.6276793,37.986915 32.9404824,37.685961 32.4410308,37.1639777 C31.9415792,36.6419945 31.6712207,35.9421951 31.69,35.22 L31.69,33.12 C31.737283,32.6834297 32.1058767,32.3526013 32.545,32.3526013 C32.9841233,32.3526013 33.352717,32.6834297 33.4,33.12 L33.4,35.22 C33.3931192,35.4878174 33.4939887,35.7471962 33.68,35.94 C33.8678088,36.1370153 34.1278124,36.2489612 34.4,36.25 L38.16,36.33 C41.2822992,36.4010129 43.7570217,38.9876126 43.69,42.11 L43.69,58.35 L13.91,58.46 Z",
    id: "Path",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(28.950973, 25.257243) rotate(-89.780000) translate(-28.950973, -25.257243) ",
    cx: 28.9509735,
    cy: 25.257243,
    rx: 8.61,
    ry: 7.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.94,34.73 L28.94,34.73 C26.6735592,34.6985907 24.5394263,33.6571925 23.12,31.89 C21.5855294,30.0130221 20.7638082,27.6541155 20.8,25.23 C20.7781858,22.807043 21.6221824,20.4559097 23.18,18.6 C24.5892656,16.8202402 26.7348515,15.7824045 29.005,15.7824045 C31.2751485,15.7824045 33.4207344,16.8202402 34.83,18.6 C36.3690782,20.4743957 37.1914065,22.835045 37.15,25.26 L37.15,25.26 C37.1702358,27.6809558 36.3303609,30.0304792 34.78,31.89 C33.3561399,33.6625575 31.2134751,34.7045383 28.94,34.73 L28.94,34.73 Z M29,17.5 C27.2423136,17.5388646 25.5901137,18.346688 24.48,19.71 C23.1781612,21.2575565 22.4692398,23.2177241 22.48,25.24 C22.441162,27.2592183 23.1217129,29.2264358 24.4,30.79 C25.5048745,32.1598944 27.1603362,32.9693126 28.92,33 L28.92,33 C30.6771427,32.9705172 32.3300201,32.1605706 33.43,30.79 C34.7310719,29.2420012 35.4398878,27.2821253 35.43,25.26 C35.4593487,23.2422944 34.7798915,21.2782387 33.51,19.71 C32.402137,18.3493123 30.7541627,17.5417683 29,17.5 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.55,22.22 C27.55,22.22 32.64,26.45 36.25,25.09 C36.25,25.09 36.06,19.09 31.6,17.27 C29.9179336,16.3401304 27.8651007,16.3898265 26.23,17.4 C21.35,19.78 21.81,26.25 21.81,26.25 C30.32,22.64 28.98,16.65 28.98,16.65",
    id: "Path",
    fill: "#DBC553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,27.5 L21,26.31 C21,26.02 20.55,19.23 25.89,16.64 C27.7452588,15.5258448 30.0486219,15.4651301 31.96,16.48 C36.87,18.48 37.14,24.79 37.15,25.06 L37.15,25.67 L36.57,25.89 C33.27,27.13 29.11,24.44 27.57,23.32 C26.0598319,24.9394715 24.2037528,26.1973667 22.14,27 L21,27.5 Z M28.17,17.56 C27.6129524,17.704825 27.0731606,17.9093424 26.56,18.17 C23.56,19.65 22.81,23.03 22.65,24.89 C27.64,22.36 28.22,19 28.21,17.56 L28.17,17.56 Z M28.59,22 C30.09,23.11 33.08,24.87 35.34,24.5 C35.14,22.99 34.34,19.34 31.29,18.11 C30.8350403,17.9176985 30.3672423,17.7573106 29.89,17.63 C29.8627082,19.1778717 29.4132037,20.6888984 28.59,22 L28.59,22 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 7.28,
    y: 53.42,
    width: 15.67,
    height: 17.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8,71.44 L6.42,71.44 L6.42,52.56 L23.8,52.56 L23.8,71.44 Z M8.13,69.73 L22.13,69.73 L22.13,54.27 L8.13,54.27 L8.13,69.73 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 4.68,
    y: 43.66,
    width: 20.79,
    height: 9.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.32,54 L3.82,54 L3.82,42.8 L26.32,42.8 L26.32,54 Z M5.53,52.24 L24.61,52.24 L24.61,44.51 L5.53,44.51 L5.53,52.24 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.74,
    y1: 44.15,
    x2: 11.74,
    y2: 53.09,
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.74,54 C11.268945,53.9945222 10.8899682,53.6110869 10.89,53.14 L10.89,44.15 C10.89,43.680558 11.270558,43.3 11.74,43.3 C12.2110869,43.3 12.5945222,43.678945 12.6,44.15 L12.6,53.09 C12.6108685,53.3258611 12.5254059,53.5560101 12.3632309,53.7276138 C12.2010559,53.8992176 11.9760985,53.9975364 11.74,54 L11.74,54 Z",
    id: "Path",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.81,
    y1: 44.15,
    x2: 18.81,
    y2: 53.09,
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.81,54 C18.3372912,53.9945971 17.9554029,53.6127088 17.95,53.14 L17.95,44.15 C17.9554778,43.678945 18.3389131,43.3 18.81,43.3 C19.279442,43.3 19.66,43.680558 19.66,44.15 L19.66,53.09 C19.6736913,53.3248914 19.590545,53.555135 19.429935,53.7270822 C19.269325,53.8990293 19.0452785,53.9976627 18.81,54 Z",
    id: "Path",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.65,
    transform: "translate(42.000000, 40.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.4,
    cy: 12.96,
    r: 12.21
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.36,66.13 C47.1802983,66.13 41.36,60.3097017 41.36,53.13 C41.36,45.9502983 47.1802983,40.13 54.36,40.13 C61.5397017,40.13 67.36,45.9502983 67.36,53.13 C67.3271528,60.2960519 61.5260519,66.0971528 54.36,66.13 Z M54.36,41.76 C49.7724885,41.76 45.6368818,44.5239873 43.8822528,48.7626827 C42.1276238,53.0013781 43.0996603,57.879698 46.3449514,61.1221272 C49.5902425,64.3645565 54.4694179,65.3322888 58.7065637,63.5739211 C62.9437095,61.8155533 65.7040454,57.6775097 65.7000044,53.09 C65.6944806,46.8309965 60.6190059,41.76 54.36,41.76 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.44,
    y1: 61.94,
    x2: 70.55,
    y2: 69.05,
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.55,69.9000375 C70.3243296,69.901702 70.1076955,69.8114378 69.95,69.65 L62.84,62.54 C62.5926291,62.2070748 62.6216607,61.7442274 62.9086938,61.4448222 C63.195727,61.1454169 63.6569381,61.0968904 64,61.33 L71.12,68.45 C71.3635329,68.6943468 71.4352243,69.0616539 71.3014491,69.3796441 C71.1676739,69.6976344 70.8549683,69.9032296 70.51,69.9000375 L70.55,69.9000375 Z",
    id: "Path",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A5BAC9",
    x: 47.89,
    y: 48.73,
    width: 13.2,
    height: 3.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,52.62 L47,52.62 L47,47.87 L62,47.87 L62,52.62 Z M48.8,50.92 L60.24,50.92 L60.24,49.58 L48.75,49.58 L48.8,50.92 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4CA585",
    x: 47.89,
    y: 55.01,
    width: 13.2,
    height: 3.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,58.91 L47,58.91 L47,54.16 L62,54.16 L62,58.91 Z M48.75,57.2 L60.24,57.2 L60.24,55.86 L48.75,55.86 L48.75,57.2 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F79669",
    x: 11.46,
    y: 57.32,
    width: 9.03,
    height: 9.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.63,58.17 L19.63,65.49 L12.31,65.49 L12.31,58.17 L19.63,58.17 M21.34,56.47 L10.6,56.47 L10.6,67.2 L21.34,67.2 L21.34,56.47 L21.34,56.47 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 27.38,
    cy: 61.19,
    r: 10.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.38,72.0500161 C22.2001228,72.0510603 17.739102,68.3969256 16.7201598,63.3182559 C15.7012175,58.2395862 18.4074631,53.1474706 23.1868736,51.1503818 C27.9662842,49.153293 33.4909188,50.8061147 36.3882742,55.0998847 C39.2856295,59.3936547 38.7506864,65.1353655 35.11,68.82 C33.0716029,70.8909851 30.2858591,72.0550152 27.38,72.0500161 L27.38,72.0500161 Z M27.38,52.05 L27.32,52.05 C22.2338184,52.0665495 18.1217374,56.1987494 18.1299997,61.2849512 C18.138287,66.371153 22.2637915,70.4899512 27.35,70.4899512 C32.4362085,70.4899512 36.561713,66.371153 36.5700003,61.2849512 C36.5782626,56.1987494 32.4661816,52.0665495 27.38,52.05 L27.38,52.05 Z",
    id: "Shape",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.57,54.64 C32.1263479,53.2199136 30.2582212,52.3104309 28.25,52.05 C32.5689879,53.8050533 34.9126583,58.4946145 33.7236003,63.0023867 C32.5345423,67.5101588 28.1827213,70.4335866 23.56,69.83 C27.6543075,71.470812 32.3378454,70.0029316 34.7632361,66.3187631 C37.1886268,62.6345946 36.6856113,57.7522615 33.56,54.64 L33.57,54.64 Z",
    id: "Path",
    fill: "#DAC556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.21,58.85 C28.719439,58.3622701 28.0614763,58.0797753 27.37,58.06 C26.9978994,58.0482777 26.6379191,58.1930476 26.37754,58.4591285 C26.117161,58.7252093 25.9802214,59.0882406 26,59.46 C26.06,60.76 28,60.86 28.62,61.75 C28.8816054,62.0916539 28.9791718,62.5313125 28.8866416,62.9515541 C28.7941113,63.3717957 28.520909,63.7298171 28.14,63.93 C27.1860965,64.2346262 26.1419383,63.9841824 25.43,63.28",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.41,64.94 C26.4661551,64.9305244 25.558678,64.5746511 24.86,63.94 C24.6331364,63.7363586 24.5321471,63.4271559 24.5950739,63.1288655 C24.6580007,62.8305751 24.8752834,62.5885145 25.1650739,62.4938655 C25.4548643,62.3992165 25.7731364,62.4663586 26,62.67 C26.4623381,63.1198028 27.121309,63.3043147 27.75,63.16 C27.8880383,63.0948994 27.9878608,62.969197 28.02,62.82 C28.0703519,62.6231085 28.0300008,62.4140164 27.91,62.25 C27.6516172,62.0133795 27.353783,61.8238487 27.03,61.69 C26.25,61.31 25.19,60.78 25.13,59.5 C25.0950325,58.909593 25.3048249,58.3308553 25.71,57.9 C26.1314319,57.4619685 26.7121621,57.2130841 27.32,57.21 C28.2215657,57.2233083 29.0838632,57.5811081 29.73,58.21 C29.9012788,58.35706 30.0070214,58.5662144 30.0239052,58.7913321 C30.0407891,59.0164498 29.9674271,59.2390371 29.82,59.41 C29.5075828,59.7627074 28.9711596,59.8026067 28.61,59.5 C28.2784412,59.1471243 27.8235161,58.9357812 27.34,58.91 C27.1934695,58.9071167 27.0522863,58.9650381 26.95,59.07 C26.8675979,59.167532 26.8247774,59.2924252 26.83,59.42 C26.83,59.66 27.12,59.83 27.83,60.16 C28.4074595,60.3979568 28.9211734,60.7678308 29.33,61.24 C29.7480139,61.8167779 29.8906853,62.5484258 29.72,63.24 C29.558751,63.8817777 29.1184066,64.41753 28.52,64.7 C28.1730806,64.863415 27.7934414,64.9454992 27.41,64.94 Z",
    id: "Path",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.47,
    y1: 57.69,
    x2: 27.46,
    y2: 55.98,
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.47,58.54 C26.9989131,58.5400318 26.6154778,58.161055 26.61,57.69 L26.61,56 C26.657283,55.5634297 27.0258767,55.2326013 27.465,55.2326013 C27.9041233,55.2326013 28.272717,55.5634297 28.32,56 L28.32,57.71 C28.3200318,58.1810869 27.941055,58.5645222 27.47,58.57 L27.47,58.54 Z",
    id: "Path",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.52,
    y1: 66.13,
    x2: 27.51,
    y2: 64.43,
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.52,67 C27.0528136,66.9945985 26.6754015,66.6171864 26.67,66.15 L26.67,64.43 C26.67,63.960558 27.050558,63.58 27.52,63.58 C27.9851296,63.585071 28.3639877,63.9551184 28.38,64.42 L28.38,66.13 C28.3800318,66.6010869 28.001055,66.9845222 27.53,66.99 L27.52,67 Z",
    id: "Path",
    fill: "#323E48"
  })))));
};
export { SvgTestClaims as ReactComponent };
export default __webpack_public_path__ + "static/media/test-claims.69781ebd.svg";